import "./styles.css";
import { useSearchResults } from "./search";
import { useState } from "react";
import More from "./More";

// to create new file, create file, export in file and import here. If using another function, make sure to import on the new file as well.
// This component is the entire application. Every time one of our values
// (`query`, or `results`) changes, this function will run again and generate
// new HTML.
export default function App() {
  const [query, setQuery] = useState("");
  // Pass our current search query to our search function and get results.
  const results = useSearchResults(query);

  return (
    <div className="App">
      <h2>Art Song Commissions</h2>
      Operatic Activism has been my mission since 2016. Since then, I've been
      commissioning, curating, and performing art music inspired by activism,
      marginalized voices, and current events. This mission has been cathartic
      for me and my audiences, so I present an ongoing list of my commissions
      below. Singers, if you wish to perform any of these works, contact the
      composer and request permission to view/perform their work! I have ongoing
      concerts with much of this repertoire and look forward to future
      anthologies. For now, enjoy this searchable list.
      <p>
        <label>
          Search:{" "}
          <input
            // The search input should always show the search query
            value={query}
            // When the user types, update our `query` variable.
            onChange={(e) => setQuery(e.target.value)}
            placeHolder="ie. feminism, youth, war, hope, etc."
            type="search"
            style={{ width: "200px" }}
          />
        </label>
      </p>
      <p></p>
      <table
        style={{
          fontFamily: "Helvetica",
          backgroundColor: "white",
          paddingBottom: 5,
          paddingLeft: 5,
          paddingTop: 5,
          border: "2px solid lightgrey",
          borderCollapse: "collapse"
        }}
      >
        <tr>
          <th style={{ textAlign: "left", width: "35%" }}>
            Work Title, Song Title
          </th>
          <th style={{ textAlign: "left", width: "20%" }}>Composer</th>
          <th style={{ textAlign: "left", width: "20%" }}>Text Author</th>
          <th style={{ textAlign: "left", width: "15%" }}>Ensemble</th>
          <th style={{ textAlign: "left", width: "10%" }}>Year</th>
        </tr>
        {/* Render our results using our special <Results /> component */}
        <Results setQuery={setQuery} results={results} />
      </table>
    </div>
  );
}

// Given an array (list) of results render the table of results
function Results({ setQuery, results }) {
  // If there are no results, show a special message
  if (results.length === 0) {
    return (
      <p>
        <strong>No results.</strong>
      </p>
    );
  }

  // Render a list of results
  return results.map((result, i) => {
    // Render each result using our special <Result /> component.
    return <Result result={result} setQuery={setQuery} key={i} />;
  });
}

// A custom component for redering a single result in the results table
function Title({ songtitle, worktitle }) {
  if (songtitle && worktitle) {
    return (
      <span>
        <i>{worktitle}</i>, {songtitle}
      </span>
    );
  }
  if (songtitle) {
    return <span>"{songtitle}"</span>;
  }
  if (worktitle) {
    return (
      <span>
        <i>{worktitle}</i>
      </span>
    );
  }
}
function Result({ setQuery, result }) {
  return (
    <tr>
      <td>
        <Title songtitle={result.songtitle} worktitle={result.worktitle} />
      </td>
      <td>{result.composer}</td>
      <td>{result.textauthor}</td>
      <td>{result.ensemble}</td>
      <td>{result.commissionyear}</td>
    </tr>
  );
}
